import gql from 'graphql-tag';

export const GET_BRAND_ASSETS_RAW = gql`
  query brand($id: ID!) {
    brand(id: $id) {
      name
      description
      rawAssets(bundle: DEFAULT_BRANDING, version: "PENDING") {
        updatedAt
        bundle
      }
    }
  }
`;

export const GET_BRAND_ASSETS = gql`
  query brand($id: ID!, $bundle: BrandAssetBundleName!, $version: String) {
    brand(id: $id) {
      name
      description
      assets(bundle: $bundle, version: $version) {
        ... on BrandAssetBundleDefaultBranding {
          updatedAt
          card {
            component
            type
            format
            height
            width
            path
          }
          icon {
            component
            type
            format
            height
            width
            path
          }
          banner {
            component
            type
            format
            height
            width
            path
          }
          primaryColor {
            component
            type
            value
          }
          secondaryColor {
            component
            type
            value
          }
          featuredBanner {
            component
            type
            format
            height
            width
            path
          }
          featuredBannerHeadline {
            component
            type
            value
          }
        }
        ... on BrandAssetBundleVenmo {
          updatedAt
          icon {
            component
            type
            format
            height
            width
            path
          }
          tile {
            component
            type
            format
            path
          }
          background {
            component
            type
            value
          }
          note {
            component
            type
            value
          }
          noteQRC {
            component
            type
            value
          }
          merchantName {
            component
            type
            value
          }
          featuredBanner {
            component
            type
            format
            height
            width
            path
          }
          featuredBannerHeadline {
            component
            type
            value
          }
          QRBanner {
            component
            type
            format
            height
            width
            path
          }
          QRHeadline {
            component
            type
            value
          }
        }
      }
      rawMatchers {
        updatedAt
        matchers
      }
      rawPlaceMatchers {
        updatedAt
        matchers
      }
    }
  }
`;

export const GET_ACCOUNT_DETAILS = gql`
  query AccountDetails($params: GetAccountDetailsInput!) {
    getAccountDetails(params: $params) {
      companyName
      firstName
      lastName
      email
      category
      subCategory
      pointOfSaleSystem
      address1
      city
      state
      postal
      phone
      numberOfStores
    }
  }
`;

export const APPROVE_BRAND_ASSETS = gql`
  mutation ApproveBrandAsset(
    $brandId: ID!
    $bundle: BrandAssetBundleName!
    $updatedAt: String!
  ) {
    approveBrandAsset(
      brandId: $brandId
      bundle: $bundle
      updatedAt: $updatedAt
    ) {
      success
    }
  }
`;

export const UPSERT_BRAND_ASSETS = gql`
  mutation upsertBrandAsset(
    $brandId: ID!
    $bundle: BrandAssetBundleName!
    $assets: [JSON!]!
  ) {
    upsertBrandAsset(brandId: $brandId, bundle: $bundle, assets: $assets) {
      success
    }
  }
`;

export const RESOLVE_ZENDESK_TICKET = gql`
  mutation updateTicket($params: TicketStatusInput!) {
    updateTicket(params: $params) {
      success
    }
  }
`;

export const GET_MERCHANT = gql`
  query GetMerchantsList($params: MerchantSearchInput) {
    merchantList(params: $params) {
      result {
        merchantId
        merchantName
        hasAccountDetails
        brandId
      }
    }
  }
`;
